import React, { PropTypes } from 'react'

const Image = (
  { base, sizes = [], excludeMin, svg, jpg, style, debug, ...otherProps },
  { width, retina }
) => {
  const postfix = sizes
    .sort((a, b) => (a > b ? 1 : -1))
    .reduce((postfix, breakpoint) => {
      if (width >= (excludeMin ? breakpoint + 1 : breakpoint)) {
        return breakpoint
      }
      return postfix
    }, 0)

  const retinaPath = retina && !svg ? '@2x' : ''
  const imageSource = `${base + (postfix > 0 ? `_min${postfix}` : '') + retinaPath}.${
    svg ? 'svg' : jpg ? 'jpg' : 'png'
  }`

  const onLoad = (img) => {
    img.target.removeAttribute('width')

    if (retina && !svg) {
      img.target.width /= 2
    }
  }

  return <img {...otherProps} src={imageSource} onLoad={onLoad} style={style} />
}

Image.contextTypes = {
  width: PropTypes.number,
  retina: PropTypes.bool
}
export default Image



// WEBPACK FOOTER //
// ../components/Image.js